import './style.css';

export const Select = ({ value, options, onChange, className }) => {
  return (
    <select className={"select-form " + className} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map(item => (<option key={item.key} value={item.key}>{item.text}</option>))}
    </select>
  );
}
